






































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { CreatePickingQuery } from '@/tenant/models/All';


@Component
export default class SalesDeliveryView extends Vue {
  public bookSales = Components.BookSales;
  public returnDelivery = Components.ReturnDelivery;
  public items: Common.SalesDelivery[] = new Array(0);
  public params: Common.DeliveryQuery = new Common.DeliveryQuery(Common.SalesPurchaseFlags.Sales);
  public importQuery = new Common.DeliveryImportQuery('出荷',Common.SalesPurchaseFlags.Sales);
  public exportQuery = new Common.DeliveryExportQuery('出荷',this.params,Common.SalesPurchaseFlags.Sales);
  public usedTypes = Common.UsedTypes;  
  public deliveryFlags = Common.DeliveryFlags;
  public hasLicenseCurrency: boolean = false;
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'deliveryNo', text: '出荷番号' },
    { value: 'deliveryDate', text: '出荷日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'receiver', text: '納入先' },
    { value: 'warehouse', text: '出庫倉庫' },
    { value: 'projectItem', text: '案件' },      
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '出荷管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;  
  @Prop() public deliveryNo:string;
  @Prop() public pickingNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  
  
  public get isBarcodeInspection(){
    return (this.$api.tenantSettings.inspectionMode & Common.InspectionModes.shipping) > 0 ;
  }
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([],0, 'grid');

  //タブ表示制御
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true];
  public tabVisiblesOnInsert: Array<boolean> = [true, true, true, true, true, false, false, false, false];  

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ
    this.$set(this.tabVisiblesOnInsert, 4, this.$api.useStockFunction); // 予備項目タブ

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('出荷番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 220),
      new Common.GridItemConfiguration('出荷日', 150),
      new Common.GridItemConfiguration('得意先', 150),
      new Common.GridItemConfiguration('納入先', 150),
      new Common.GridItemConfiguration('納入先名称', 150),
      new Common.GridItemConfiguration('納入区分', 150),
      new Common.GridItemConfiguration('出庫倉庫', 150),
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),
      // new Common.GridItemConfiguration('計上レート', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('出荷金額', 150),
      new Common.GridItemConfiguration('税計算区分', 150),
      new Common.GridItemConfiguration('案件', 150),             
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('出荷管理番号', 150),
      new Common.GridItemConfiguration('運送会社', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );


    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.deliveryNo) {
      this.params.deliveryNo = this.deliveryNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}

    if (this.pickingNo) {
      this.params.pickingNo = this.pickingNo;
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_aloneInvoice');
    this.$api.formatter.ensureListLoaded('workflow_carryOverInvoice');
  }

  public forwarderTimezoneFlags(item: Common.SalesDelivery){
    if (item.forwarder == Common.ForwarderFlags.Default) return new Array(0);

    var timeZoneArray = new Array();
    if (item.forwarder == Common.ForwarderFlags.Sagawa) {
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Default);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone0812);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1214);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1416);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1618);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1820);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1821);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1921);
    } else if (item.forwarder == Common.ForwarderFlags.Yamato) {
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Default);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone0812);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1416);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1618);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1820);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1921);
    } else if (item.forwarder == Common.ForwarderFlags.Seinou) {
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Default);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone0812s);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1220);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone0912);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1217);
        timeZoneArray.push(Common.ForwarderTimezoneFlags.Timezone1720);
    }

    var list = this.$api.formatter.getOptions("forwarderTimezoneFlags");
    var result = new Array(0);
    list.forEach(element => {
        if (timeZoneArray.includes(element.value) == true) result.push(element) ;            
    });
    return result;
  }

  public async onCreate(obj: Common.SalesDelivery) {
    const workflows = this.$api.formatter.getOptions('workflow_salesDelivery');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    obj.deliveryDate = new Date().getCalendarDate();
    obj.deliveryFlag = (this.$api.useStockFunction) ? Common.DeliveryFlags.Stock : Common.DeliveryFlags.Services;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //出荷明細タブのリロード
    (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  // 状態から編集可能か判別する
  public isEditable(state: Common.DeliveryStatus, flag:Common.DeliveryFlags, isDisableDirect:boolean):boolean{
    if(isDisableDirect && flag == Common.DeliveryFlags.Direct) return false;
    if(state == Common.DeliveryStatus.SalesDeliveryPostWaiting) return true;
    return false;
  }

  // 得意先変更時に得意先の通貨を設定する
  public onChangeCustomer(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    if (item.counterpart && item.counterpart.salesPerson) item.pic = item.counterpart.salesPerson;    
    item.onChangeCounterpart();
  }

  // 納入先変更時に納入先詳細を設定する
  public onChangeReceiver(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeReceiver();
  }

  public async onChangeCurrency(item: Common.Delivery){
    const query = new Common.GetExchangeRateQuery();
    query.currency = item.currencyCode;
    query.startDate = item.deliveryDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      item.exchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }

  public onChangeDeliveryFlag(item: Common.Delivery){
    if(item.deliveryFlag == Common.DeliveryFlags.Services) item.warehouse = null;
  }

  // 一覧選択時に明細表示ボタン、部門の非活化状態確認
  public onSelectedMain(index: number, selected: Common.Delivery) {
    this.checkItemData(selected);
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  checkItemData(delivery:Common.Delivery){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetDeliveryItemQuery();
    query.deliveryNo = delivery.deliveryNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = !res.hasItem;
      delivery.hasOrder = res.hasOrder;
    });
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.SalesDelivery){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesDelivery, sourceNo : item.deliveryNo},this.$el);
  }
  // 出荷明細一覧を表示
  public showSalesDeliveryItem() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
    if(obj.state == Common.DeliveryStatus.SalesDeliveryPostWaiting){
      let routeData = this.$router.resolve(String.format('/sales/SalesDeliveryItem?deliveryNo={0}', obj.deliveryNo));
      window.open(routeData.href, '_blank');
    }else{
      let routeData = this.$router.resolve(String.format('/sales/InvoiceItem?deliveryNo={0}', obj.deliveryNo));
      window.open(routeData.href, '_blank');
    }
  }

  // 明細一括入力ボタンの非活性判別
  public disabledAddItemButton(delivery: Common.SalesDelivery){
    return delivery.state != Common.DeliveryStatus.SalesDeliveryPostWaiting;
  }

  // 明細一括入力ダイアログ用プロパティ
  public badiCaptions = new Array();
  public badiWidths = new Array();
  public badiSlots = new Array();
  public badiGridConfig:Common.GridConfiguration =null;
  public badiPurchaseItemIdRequreid: boolean; // 入荷明細番号必須・活性を判別

  // 明細一括入力ダイアログを表示
  public showBundleAddDeliveryItemDialog() {
    const selectedDelivery = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
      // 新規の場合、編集中のものを設定
    if(selectedDelivery.counterpart == null){
      this.$api.modal.show('', '得意先を指定してください。', true, null);
      return ;
    }
    if(selectedDelivery.deliveryFlag == Common.DeliveryFlags.Stock && selectedDelivery.warehouse == null){
      this.$api.modal.show('', '出庫倉庫を指定してください。', true, null);
      return ;
    }
    if(selectedDelivery.deliveryFlag == Common.DeliveryFlags.Stock) this.showStockBalanceButton = true;
    else this.showStockBalanceButton = false;
    // プロパティの設定
    this.badiPurchaseItemIdRequreid = selectedDelivery.segment.priceCalculationMethod == Common.PricingTypes.Specific;

    // 明細の予備項目表示の可変対応
    this.badiGridConfig = new Common.GridConfiguration([],0,'col');
    this.badiGridConfig.setGridItems(
      new Common.GridItemConfiguration('入荷明細番号', 150,this.badiPurchaseItemIdRequreid),
      new Common.GridItemConfiguration('商品', 250),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 200, this.$api.useStockFunction),
      new Common.GridItemConfiguration('庫内数量', 130),      
      new Common.GridItemConfiguration('単位', 120),
      new Common.GridItemConfiguration('出荷数量', 130),
      new Common.GridItemConfiguration('単価', 130),
      new Common.GridItemConfiguration('税区分', 120)      
    );
    this.badiGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,false,false,true));//商品識別情報＋在庫識別情報＋商品メモ＋入出荷メモ
    this.badiCaptions =this.badiGridConfig.gridCaptions;
    this.badiWidths = this.badiGridConfig.gridWidths;
    this.badiSlots = this.badiGridConfig.gridSlots;

    // ダイアログの表示
    var items = new Array();
    var instance = new Common.SalesDeliveryItem();
    //instance.taxCode = selectedDelivery.counterpart.taxCode;
    //納入区分が在庫の場合は明細行を追加しない
    if(selectedDelivery.deliveryFlag == Common.DeliveryFlags.Services) items.push(instance);
    (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).items = items;
    (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).showDialog();
  }

  //明細一括入力ダイアログの予備項目の活性・非活性を切り替える
  public isEditable2(usedType: Common.UsedTypes, isStockBalance = false){
    //商品識別情報・在庫識別情報・入出荷メモは活性。それ以外は非活性
        if(usedType == Common.UsedTypes.CommodityAttribute && isStockBalance == false)  return true;
        if(usedType == Common.UsedTypes.StockAttribute && isStockBalance == false) return true;
        if(usedType == Common.UsedTypes.DeliveryMemo) return true;
        return false;
  }

  // 商品変更時に商品名・単価・税区分・予備項目を設定する
  public onChangeCommodity(item:Common.DeliveryItem){
    item.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(item);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.DeliveryItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
    this.$api.execute(new Common.DeliveryGetItemPriceQuery(parent, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  //行追加時に税区分の初期値を設定 ⇒ 商品選択時にセットされるため廃止
  public async onItemCreate(obj:Common.DeliveryItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
    //obj.taxCode = parent.counterpart.taxCode;
    return Promise.resolve(obj);
  }

  public showStockBalance:boolean = false;
  public showStockBalanceButton: boolean = false;
  public onAddDeliveryItems(parent:Common.Delivery){
    //選択された在庫からdeliveryItemを生成する
    var selectedItems = ((this.$refs.stockBalance as Components.StockBalance).$refs.mainList as Components.ListView).selectedItems as Common.StockBalance[];
    selectedItems.forEach(stock =>{
      var deliveryItem = new Common.SalesDeliveryItem();
      deliveryItem.isStockBalance = true;
      deliveryItem.stockQuantity2 = stock.stockQuantity;
      deliveryItem.commodity = stock.stockKey.commodity;
      deliveryItem.commodityName = deliveryItem.commodity ? deliveryItem.commodity.name: '';
      deliveryItem.sku = stock.stockKey.sku;
      deliveryItem.reserveText1 = stock.stockKey.reserveText1;
      deliveryItem.reserveText2 = stock.stockKey.reserveText2;
      deliveryItem.reserveText3 = stock.stockKey.reserveText3;
      deliveryItem.reserveText4 = stock.stockKey.reserveText4;
      deliveryItem.reserveText5 = stock.stockKey.reserveText5;
      deliveryItem.reserveText6 = stock.stockKey.reserveText6;               
      deliveryItem.reserveMemo1 = stock.stockKey.reserveMemo1;
      deliveryItem.reserveMemo2 = stock.stockKey.reserveMemo2;
      deliveryItem.reserveMemo3 = stock.stockKey.reserveMemo3;                  
      deliveryItem.reserveDate1 = stock.stockKey.reserveDate1;
      deliveryItem.reserveDate2 = stock.stockKey.reserveDate2;
      deliveryItem.reserveDate3 = stock.stockKey.reserveDate3;          
      deliveryItem.reserveList1 = stock.stockKey.reserveList1;
      deliveryItem.reserveList2 = stock.stockKey.reserveList2;
      deliveryItem.reserveList3 = stock.stockKey.reserveList3;           
      (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).onAddItem(deliveryItem);                  
    });
    this.showStockBalance = false; 
  }
public submitBundleAddDeliveryItemRun(){
  const items = (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).items;
  if(items.length > 0) this.submitBundleAddDeliveryItem(items);
}
  // 明細一括入力の実行
  public async submitBundleAddDeliveryItem(list: Array<Common.DeliveryItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesDelivery;
    var items = new Array();
    for(var obj of list){
      obj.delivery = parent;
      obj.segment = parent.segment;
      obj.warehouse = parent.warehouse;
      items.push(obj);
    }
    if(items.filter(item => !item.commodity.isNoStock).length > 0 && parent.warehouse == null){
      this.$api.modal.show('無効な操作','倉庫の指定がありません。在庫から出荷する場合、出庫倉庫を指定してください。',true,null);
      return true;
    }
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddDeliveryItemQuery(Common.SalesPurchaseFlags.Sales);
    query.deliveryItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/sales/SalesDeliveryItem?deliveryNo={0}', parent.deliveryNo));
    // });

    return this.$api.execute(query).then(res => {
      //出荷金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res).finally(()=>{
        //出荷明細タブのリロード
        (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();    
        //事後アクションダイアログを表示するためコメントアウト   
        //this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      });
      return true;
    }).catch(()=>{return false;});    
  }
  // チェックされている発注明細を取得する
  public selectedSalesDeliveryItems(){
    return (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).selectedItems;
  }
  public allSalesDeliveryItems(){
    return (this.$refs.salesDeliveryItems as Components.GrdVoucherItem).items;
  }  
  // 請求処理ボタンの非活性判別
  public disabledDeliveryItemFuncButton(delivery:Common.SalesDelivery){
    return delivery.state != Common.DeliveryStatus.SalesDeliveryItemsOperateWaiting && delivery.state != Common.DeliveryStatus.SalesDeliveryItemsOperating;
  }
  // 返品処理ボタンの非活性判別
  public disabledReturnDeliveryItemFuncButton(delivery:Common.SalesDelivery){
    return delivery.state != Common.DeliveryStatus.SalesDeliveryItemsOperateWaiting && delivery.state != Common.DeliveryStatus.SalesDeliveryItemsOperating && delivery.state != Common.DeliveryStatus.SalesDeliveryCompleted;
  }
  // 請求処理ダイアログの表示
  public showBookSalesDialog(delivery:Common.SalesDelivery, all:boolean = false){
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesDelivery;
    let componentClass = Vue.extend(this.bookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execDelivery: false,
          checkedDeliveryItems: all? this.allSalesDeliveryItems() : this.selectedSalesDeliveryItems(),
          salesDeliveryItems: this.$refs.salesDeliveryItems,
          parentMainList: this.$refs.mainList,
          parentSalesDelivery: delivery,
          parent: this,
          isItemFlag: false,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 返品処理ダイアログの表示
  public showReturnDeliveryDialog(delivery:Common.SalesDelivery){
    let componentClass = Vue.extend(this.returnDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          parentDelivery: delivery,
          checkedDeliveryItems: this.selectedSalesDeliveryItems(),
          salesPurchaseFlag: Common.SalesPurchaseFlags.Sales,
          parentMainList: this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 業務処理・一括請求処理からの請求処理
  public showBookSalesDialogBulk(){
    const listView = this.$refs.mainList as Components.ListView;
    var deliveries = new Array();
    var checkedDeliveries = new Array();
    this.items.forEach((obj, index) => {
      if ((listView.$refs.listBox as Components.Grid).checked[index]) {
        checkedDeliveries.push(obj);
      }
    });
    if(checkedDeliveries.length == 0){
      this.$api.modal.show('', '出荷伝票を選択して下さい。', true, null);
      return;
    }
    deliveries = checkedDeliveries.filter(obj => obj.state >= Common.DeliveryStatus.SalesDeliveryItemsOperateWaiting && obj.state < Common.DeliveryStatus.SalesDeliveryCompleted);
    if(deliveries.length == 0){
      this.$api.modal.show('', '「請求処理待ち」か「請求処理中」の出荷伝票を選択してください。', true, null);
      return ;
    }
    var getCounterpart = new Common.GetDeliveriesCounterpart();
    getCounterpart.deliveries = deliveries;
    this.$api.execute(getCounterpart).then(res => {
      var counterparts = res as Common.Counterpart[];
      if(counterparts.filter(obj => (obj.payer??obj).invoiceType==Common.InvoiceTypes.SeparateInvoice).length > 0){
        this.$api.modal.show('', '個別請求が指定されている請求先に対して一括請求は行えません。個別に請求処理を行ってください。', true, null);
        return ;
      }
      // deliveryの取引先を最新化
      deliveries.forEach(obj=>obj.counterpart = counterparts.filter(cus => cus.id == obj.counterpartId)[0]);
      const bookdateTime=(deliveries[0].counterpart.payer ?? deliveries[0].counterpart).getClosingDate(deliveries[0].deliveryDate, this.$api.tenantSettings).getTime();
      if(deliveries.filter(obj => (obj.counterpart.payer ?? obj.counterpart).getClosingDate(obj.deliveryDate, this.$api.tenantSettings).getTime() != bookdateTime).length > 0){
        this.$api.modal.show('', '締日の異なる伝票が選択されています。同一の締日となる出荷伝票を選択して下さい。同一の締日は検索項目の【得意先締日】と【出荷日】で検索してください。', true, null);
        return ;
      }
    let componentClass = Vue.extend(this.bookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execDelivery: true,
          deliveries: deliveries,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: false,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
    });
  }
  
  // 業務処理・個別請求処理からの請求処理
  public showBookSalesDialogSeparate(){
    const listView = this.$refs.mainList as Components.ListView;
    var deliveries = new Array();
    var checkedDeliveries = new Array();
    this.items.forEach((obj, index) => {
      if ((listView.$refs.listBox as Components.Grid).checked[index]) {
        checkedDeliveries.push(obj);
      }
    });
    if(checkedDeliveries.length == 0){
      this.$api.modal.show('', '出荷伝票を選択して下さい。', true, null);
      return;
    }
    deliveries = checkedDeliveries.filter(obj => obj.state >= Common.DeliveryStatus.SalesDeliveryItemsOperateWaiting && obj.state < Common.DeliveryStatus.SalesDeliveryCompleted);
    if(deliveries.length == 0){
      this.$api.modal.show('', '「請求処理待ち」か「請求処理中」の出荷伝票を選択してください。', true, null);
      return ;
    }

    // 請求先の一意確認
    var payerIds = deliveries.map(obj => obj.counterpart.payerId ?? obj.counterpartId);
    if(payerIds.filter(obj => obj != payerIds[0]).length > 0){
      this.$api.modal.show('', '請求先の異なる伝票が選択されています。同一の請求先である出荷伝票を選択して下さい。', true, null);
      return ;
    }
    var getCounterpart = new Common.GetDeliveriesCounterpart();
    getCounterpart.deliveries = deliveries;

    this.$api.execute(getCounterpart).then(res => {
      var counterparts = res as Common.Counterpart[];
      // deliveryの取引先を最新化
      deliveries.forEach(obj=>obj.counterpart = counterparts.filter(cus => cus.id == obj.counterpartId)[0]);
      const bookdateTime=(deliveries[0].counterpart.payer ?? deliveries[0].counterpart).getClosingDate(deliveries[0].deliveryDate, this.$api.tenantSettings).getTime();
    let componentClass = Vue.extend(this.bookSales);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execDelivery: true,
          deliveries: deliveries,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: false,
          isSeparate: true,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
    });
  }

  // 出荷伝票削除処理用
  public deleteMessage: string ='';
  public allocateDelete:boolean=false;
  public onDelete()
  {
      const listView = this.$refs.mainList as Components.ListView;
      let count = 0;
      (listView.$refs.listBox as Components.Grid).checked.forEach(obj => (count += obj ? 1 : 0));
      this.deleteMessage = count + '件のデータを本当に削除してよろしいですか?';
      this.allocateDelete=true;
      (this.$refs.deliveryDeleteDialog as Components.ListDialog).showDialog();
  }
  public async onSalesDeliveryDelete(){
    var listView = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((listView.$refs.listBox as Components.Grid).checked[index]) {
        obj.allocateDeleteFlag = this.allocateDelete;
      }
    });
    const targetList = new Array(0);
    this.items.forEach((obj, index) => {
      if ((listView.$refs.listBox as Components.Grid).checked[index]) {
        targetList.push(obj);
      }
    });
    listView.delete(targetList).then(()=>{
        listView.onPageChange(this.params.currentPage);
      });
      listView.$emit('updated');
  }

  //---------------- ピッキング -----------------
  public showPicking:boolean = false;
  public pickingDate: Date;
  public pickingPic: string = '';
  public pickingDescription:string = null;

  public showPickingDialog(){
    var items = (this.$refs.mainList as Components.ListView).selectedItems as Common.Delivery[];
    if(items.length == 0){
      this.$api.modal.show('無効な操作','「出荷確定待ち」の在庫出荷伝票を選択してください。',true,null);
      return true;      
    }
    if(items.filter(item => item.deliveryFlag != Common.DeliveryFlags.Stock).length > 0){
      this.$api.modal.show('無効な操作','「出荷確定待ち」の在庫出荷伝票を選択してください。',true,null);
      return true;
    }    
    if(items.filter(item => item.state != Common.DeliveryStatus.SalesDeliveryPostWaiting).length > 0){
      this.$api.modal.show('無効な操作','「出荷確定待ち」の在庫出荷伝票を選択してください。',true,null);
      return true;
    }        
    if(items.filter(item => item.warehouseId != items[0].warehouseId).length > 0){
      this.$api.modal.show('無効な操作','同一倉庫の出荷伝票を選択してください。',true,null);
      return true;
    }
    if(items.filter(item => item.segmentId != items[0].segmentId).length > 0){
      this.$api.modal.show('無効な操作','同一部門の出荷伝票を選択してください。',true,null);
      return true;
    }
    if(items.filter(item => item.pickingNo).length > 0){
      var deliveryNo = items.filter(item =>item.pickingNo).map(item =>item.deliveryNo).join('/');
      this.$api.modal.show('無効な操作','以下のピッキング処理済みの出荷伝票は選択できません。\r\n' + deliveryNo,true,null);
      return true;
    }        
    this.pickingDate = new Date().getCalendarDate(); //今日
    this.pickingPic = this.$api.auth.userId; //自分
    this.pickingDescription = null;
    this.showPicking = true;
  }
  public createPicking(event:any){

    const vDate = (this.$refs.pickingDate as any) as Components.IControl;
    const vPIC = (this.$refs.pickingPIC as any) as Components.IControl;

    var validated1 = vDate.validator.validate();
    var validated2 = vPIC.validator.validate();

    if (validated1 == false || validated2 == false) {
      event.cancel();
      return;
    }

    this.$api.execute(new CreatePickingQuery((this.$refs.mainList as Components.ListView).selectedItems, this.pickingDate,this.pickingDescription,this.pickingPic))
    .then(res =>{
      var deliveries = res as Common.SalesDelivery[];
      deliveries.forEach(obj => {
        this.$set(this.items, this.items.findIndex(item => item.deliveryNo == obj.deliveryNo),obj);
      });      
      this.$api.modal.show('処理結果','以下のピッキング伝票が作成されました。',false,()=>{
          this.$router.push(String.format('/sales/SalesPicking?pickingNo={0}',deliveries[0].pickingNo));
      },[new Common.ModalLink(deliveries[0].pickingNo, String.format('/sales/SalesPicking?pickingNo={0}',deliveries[0].pickingNo))], '伝票に移動する','閉じる');      
    });
  }
  // 個別帳票出力
  public showCustomerReport(isMail: boolean = false){
    var listView = this.$refs.mainList as Components.ListView;
    listView.selectedItems.forEach(item =>{ item.designationReportTemplateId = item.counterpart.salesDeliveryReportTemplateId;});
    if (isMail) (this.$refs.menuBar as Components.ListViewMenuBar).beforeDesignationReportSend(); // 得意先指定帳票メール送信前処理
    else (this.$refs.menuBar as Components.ListViewMenuBar).onDesignationReportGenerate();
    // const targetList = new Array(0);
    // this.items.forEach((obj, index) => {
    //   if ((listView.$refs.listBox as Components.Grid).checked[index]) {
    //     targetList.push(obj);
    //   }
    // });
    // if(targetList.length > 1){
    //   this.$api.modal.show('', '単一の伝票を選択してください。', true, null);
    //   return ;
    // }
    // var templates = (this.$refs.menuBar as Components.ListViewMenuBar).reports;
    // var template = templates.filter(obj => obj.id == targetList[0].counterpart.salesDeliveryReportTemplateId)[0];
    // if(template==null){
    //   this.$api.modal.show('', '出荷一覧指定帳票が指定されていません。取引先マスタで出荷一覧指定帳票を設定してください。', true, null, [new Common.ModalLink('設定の方法はこちら','https://support.s-flow.net/ja/articles/8159389',true)]);
    //   return ;
    // }
    // var query = new Common.ReportQuery2(template.queryName, targetList);
    // query.templateId = template.id;
    // this.$api.download(query); 
  }
}
